import { Container, Row, Col } from "react-bootstrap";

import logo from "../assets/images/sethu-logo.png";
import navIcon1 from "../assets/img/nav-icon4.png";
import navIcon2 from "../assets/img/nav-icon2.svg";
import navIcon3 from "../assets/img/nav-icon3.svg";
import navIcon4 from "../assets/img/linkedin.png";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <a href="https://sethu.ac.in/" target="_blank">
              <img src={logo} alt="Logo" />
            </a>
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon mt-4">
              <a href="https://www.facebook.com/sethuinstitute/" target="_blank"><img src={navIcon2} alt="Icon" /></a>
              <a href="https://in.linkedin.com/company/sethu-institute-of-techonology" target="_blank"><img src={navIcon4} alt="Icon" /></a>
              <a href="https://www.instagram.com/neuraverse._25_?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank"><img src={navIcon3} alt="Icon" /></a>
              <a href="https://maps.app.goo.gl/hbZvu9JTexLedFo37" target="_blank"><img src={navIcon1} alt="Icon" /></a>
            </div>
            <p>Copyright {new Date().getFullYear()}. All Rights Reserved by AIML Department</p>
          </Col>
        </Row>
        <hr />
        <Row className="mt-3">

          <Col className="text-center">
            <a href="www.linkedin.com/in/vigneshwaran-b-9963b1317" className="text-center" target="_blank" style={{ textDecoration: 'none' }}>
              <p>Developed by Vigneshwaran B - 3<sup>rd</sup> year AIML dept</p>
            </a>
          </Col>

        </Row>
      </Container>
    </footer>

  )
}
